import type { AccountDetails } from '@/modules/projects/components/Workbench/accounts'
import { missingMonths } from '@/modules/projects/components/Workbench/coverage'
import type { MapLane } from '@/modules/projects/components/Workbench/map'
import { LaneHeader } from './LaneHeader'

export interface LaneActions {
  onEditAccount: (accountId: string, details: AccountDetails) => void
  onRemoveAccount: (accountId: string) => void
}

interface AccountLaneHeaderProps {
  lane: MapLane
  laneActions: LaneActions
  filingShown?: boolean
}

export const AccountLaneHeader = ({
  lane,
  laneActions,
  filingShown = true,
}: AccountLaneHeaderProps) => (
  <LaneHeader
    lane={lane}
    missing={missingMonths(lane)}
    filingShown={filingShown}
    onEdit={(details) => {
      if (lane.accountId) laneActions.onEditAccount(lane.accountId, details)
    }}
    onRemove={() => {
      if (lane.accountId) laneActions.onRemoveAccount(lane.accountId)
    }}
  />
)
